/**
 * Main component for managing top-level routes, including public routes
 *
 * Note: The <Switch /> will render the first route that matches
 * and effectively matches the last pathless-route (by default, the not found page)
 * if there are no other matching routes.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import SignUpContainer from 'components/SignUp/SignUpContainer';
import MissionCtrlContainer from '../../MissionCtrl/MissionCtrlContainer';
import AuthorizedRouteContainer from '../../AuthorizedRoute/AuthorizedRouteContainer';
import PublicRoutes from './PublicRoutes/PublicRoutes';
import SignUpRedirect from '../../SignUp/SignUpRedirect/SignUpRedirect';
import InstancesPageRedirect from '../../MissionCtrl/InstancesPageRedirect/InstancesPageRedirectContainer';
import ErrorPageContainer from '../../ErrorPage/ErrorPageContainer';

const propTypes = {
  isAuthenticated: PropTypes.func.isRequired,
  needsSignUpSteps: PropTypes.bool.isRequired,
};

function Routes({ isAuthenticated, needsSignUpSteps }) {
  const isNotSignedUp = isAuthenticated() && needsSignUpSteps;
  // If the user is signed up, add a catch-all route that redirects to the signUp
  // flow. Otherwise, add the public routes so they can be accessed.
  const additionalRoute = isNotSignedUp ? (
    <AuthorizedRouteContainer component={SignUpRedirect} />
  ) : (
    <AuthorizedRouteContainer path="/mission-ctrl" component={MissionCtrlContainer} />
  );

  return (
    <Switch>
      {PublicRoutes()}
      <AuthorizedRouteContainer path="/sign-up" component={SignUpContainer} />
      <AuthorizedRouteContainer path="/aws_onboarding" component={SignUpContainer} />
      {additionalRoute}
      <Route exact path="/" component={InstancesPageRedirect} />
      <Route render={() => <ErrorPageContainer match={{ params: { statusCode: '404' } }} />} />
    </Switch>
  );
}

Routes.propTypes = propTypes;

export default Routes;
